export default "/assets/ollie_calculator-0dfbc2bf2d12e5906a3bd462b4285c9614c92356d4ff0b1e9a7531440eca412f.svg";